module.exports = __webpack_public_path__ + "static/wireframesDesktop-beafb02f8591399576b0c9fe5100a754.png";